import type { IconSvgObject } from './types';

const BookCopyIcon: IconSvgObject = [
  ["path", { d: "M21 16H11C9.89543 16 9 15.1046 9 14M9 14C9 12.8954 9.89543 12 11 12H21V2H11C9.89543 2 9 2.89543 9 4V14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 12C20.5 12 19.5 12.7628 19.5 14C19.5 15.2372 20.5 16 20.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.5 20C13.5 21.2372 14.5 22 14.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15 22H5C3.89543 22 3 21.1046 3 20M7 18H5C3.89543 18 3 18.8954 3 20M3 20V10C3 8.89543 3.89543 8 5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default BookCopyIcon;
